<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="wrapper">
  <div class="body-wrapper">
    <div class="action-wrapper">
      <div>
          <mat-form-field class="search-input" appearance="outline">
              <mat-label>{{'DSS_SEARCH' | translate}}</mat-label>
              <input matInput type="text" placeholder="Search" [(ngModel)]="searchTerm"
                     (keydown.enter)="filterSubscriptions()" maxlength="255"/>
              <button matSuffix mat-icon-button (click)="clearSearchTerm()"><span class="mdi mdi-close" aria-hidden="true"></span></button>
              <button matSuffix mat-icon-button (click)="filterSubscriptions()"><span class="mdi mdi-magnify" aria-hidden="true"></span></button>
          </mat-form-field>
      </div>
      <div class="filters-label-wrapper">
        <span>{{'encryption-events-viewer.filters-label' | translate}}: </span>
      </div>
      <div id="encryption-event-types" class="filter-wrapper">
          <mat-form-field appearance="outline" class="filter-selector">
              <mat-label>{{'EVI_EVENT_FILTER' | translate}}</mat-label>
              <mat-select [formControl]="eventTypeForm" multiple (selectionChange)="onEventTypeChange()">
                  <mat-select-trigger>
                      {{eventTypeForm.value != undefined && eventTypeForm.value.length > 0 ? eventTypeForm.value[0] : ''}}
                      <span *ngIf="eventTypeForm.value?.length > 1" class="additional-selection">
                          (+{{eventTypeForm.value.length - 1}} {{eventTypeForm.value?.length === 2 ? 'other' : 'others'}})
                      </span>
                  </mat-select-trigger>
                  <mat-option *ngFor="let eventType of eventTypes;" id="event-type" [value]="eventType.value">{{eventType.value}}</mat-option>
              </mat-select>
          </mat-form-field>
      </div>
      <div id="encryption-key-types" class="filter-wrapper">
          <mat-form-field appearance="outline" class="filter-selector">
              <mat-label>{{'encryption-events-viewer.columns.key-scope' | translate}}</mat-label>
              <mat-select [formControl]="scopeForm" multiple (selectionChange)="onScopeChange()">
                  <mat-select-trigger>
                      {{scopeForm.value != undefined && scopeForm.value.length > 0 ? scopeForm.value[0].display : ''}}
                      <span *ngIf="scopeForm.value?.length > 1" class="additional-selection">
                          (+{{scopeForm.value.length - 1}} {{scopeForm.value?.length === 2 ? 'other' : 'others'}})
                      </span>
                  </mat-select-trigger>
                  <mat-option *ngFor="let scope of scopeTypes;" id="key-type" [value]="scope.value">{{scope.value.display}}</mat-option>
              </mat-select>
          </mat-form-field>
      </div>

      <div style="flex-grow: 2">
      </div>
      <div class="export-button-wrappers">
          <button mat-flat-button color="primary" style="margin-right: 1em" (click)="exportCSV()">{{'EVI_EXPORT_CSV' | translate}}</button>
          <button mat-flat-button color="primary" (click)="exportJSON()">{{'EVI_EXPORT_JSON' | translate}}</button>
      </div>
    </div>
    <div class="events-header">
        <div class="event-count">{{dataSource.count | number}} {{'EVI_EVENT_NUMBER' | translate}}</div>
        <app-column-chooser saveId="encryption-events" [elements]="columns" (change)="updateDisplayedColumns($event)"></app-column-chooser>
    </div>
    <div class="table-wrapper" (scroll)="tableScroll($event)">
        <table mat-table [dataSource]="dataSource" matSortActive="dttm" matSortDirection="desc" matSort
               (matSortChange)="sortColumn($event)" aria-label="A list of encryption events">
            <ng-container matColumnDef="dttm">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'encryption-events-viewer.columns.dttm' | translate}}</th>
                <td mat-cell *matCellDef="let event">{{event.dttm | date : 'medium'}}</td>
            </ng-container>

            <ng-container matColumnDef="clientDttm">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'encryption-events-viewer.columns.client-dttm' | translate}}</th>
                <td mat-cell *matCellDef="let event">{{event.clientDttm | date : 'medium'}}</td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'encryption-events-viewer.columns.email' | translate}}</th>
                <td mat-cell *matCellDef="let event">{{event.email}}</td>
            </ng-container>

            <ng-container matColumnDef="computerName">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'encryption-events-viewer.columns.computer-name' | translate}}</th>
                <td mat-cell *matCellDef="let event">{{event.computerName}}</td>
            </ng-container>

            <ng-container matColumnDef="keyName">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'encryption-events-viewer.columns.key-name' | translate}}</th>
                <td mat-cell *matCellDef="let event">{{event.keyName}}</td>
            </ng-container>

            <ng-container matColumnDef="keyScope">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'encryption-events-viewer.columns.key-scope' | translate}}</th>
                <td mat-cell *matCellDef="let event">{{ 'encryption-events-viewer.key-scope.' + event.scope | translate }}</td>
            </ng-container>

            <ng-container matColumnDef="clientId">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'encryption-events-viewer.columns.client-id' | translate}}</th>
                <td mat-cell *matCellDef="let event">{{event.clientId}}</td>
            </ng-container>

            <ng-container matColumnDef="eventType">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'encryption-events-viewer.columns.event-type' | translate}}</th>
                <td mat-cell *matCellDef="let event">{{eventNames[event.eventType]}}</td>
            </ng-container>

            <ng-container matColumnDef="consumer">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'encryption-events-viewer.columns.consumer' | translate}}</th>
                <td mat-cell *matCellDef="let event">{{event.consumer}}</td>
            </ng-container>

            <ng-container matColumnDef="userName">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'encryption-events-viewer.columns.user-name' | translate}}</th>
                <td mat-cell *matCellDef="let event">{{event.userName}}</td>
            </ng-container>

            <ng-container matColumnDef="userUid">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'encryption-events-viewer.columns.user-uid' | translate}}</th>
                <td mat-cell *matCellDef="let event">{{event.userUid}}</td>
            </ng-container>

            <ng-container matColumnDef="fileName">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'encryption-events-viewer.columns.file-name' | translate}}</th>
                <td mat-cell *matCellDef="let event">{{event.fileName}}</td>
            </ng-container>

            <ng-container matColumnDef="folderName">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'encryption-events-viewer.columns.folder-name' | translate}}</th>
                <td mat-cell *matCellDef="let event">{{event.folderName}}</td>
            </ng-container>

            <ng-container matColumnDef="dataId">
                <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{'encryption-events-viewer.columns.data-id' | translate}}</th>
                <td mat-cell *matCellDef="let event">{{event.dataId}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
            <tr mat-row *matRowDef="let event; columns: columnsToDisplay"></tr>
        </table>
    </div>
  </div>
</div>
